var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCloseAlt42X42 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 42 42"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "M21.006 32q2.255 0 4.246-.863a11.25 11.25 0 0 0 5.89-5.893q.858-1.99.858-4.256 0-2.253-.857-4.244a11.2 11.2 0 0 0-2.379-3.51 11.2 11.2 0 0 0-3.512-2.377A10.7 10.7 0 0 0 20.994 10q-2.255 0-4.246.857-1.99.857-3.512 2.377c-1.522 1.52-1.807 2.184-2.379 3.51A10.6 10.6 0 0 0 10 20.988q0 2.266.863 4.256a11.3 11.3 0 0 0 2.379 3.51 11.2 11.2 0 0 0 3.506 2.383q1.991.863 4.258.863",
  opacity: 0.9
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.999 19.938 17.63 16.57l-.066-.059a.755.755 0 0 0-.994.059l-.073.084a.75.75 0 0 0 .073.976L19.938 21l-3.368 3.37-.059.066a.755.755 0 0 0 .059.994l.084.073a.75.75 0 0 0 .976-.073L21 22.061l3.37 3.37.066.058c.314.234.73.205.994-.059l.073-.084a.75.75 0 0 0-.073-.976L22.061 21l3.37-3.37.058-.066a.755.755 0 0 0-.059-.994.75.75 0 0 0-1.06 0z"
}))));
export default SvgIcCloseAlt42X42;